const initialState = {
  errorMsgVisible: false,
  errorMsg: 'Virhe palvelussa. Päivitä selain tai yritä myöhemmin uudelleen.',
};

export default function update(state = initialState, action) {
  switch (action.type) {
    case 'SHOW_SERVER_ERROR_MSG':
      return Object.assign({}, state, {
        errorMsgVisible: action.serverError,
      });
    default:
      return state;
  }
}
